// src/utils/getThreadMessageText.tsx
var getThreadMessageText = (message) => {
  const textParts = message.content.filter(
    (part) => part.type === "text"
  );
  return textParts.map((part) => part.text).join("\n\n");
};
export {
  getThreadMessageText
};
//# sourceMappingURL=getThreadMessageText.js.map